<template>

    <div class="modal fade" ref="modal" id="loginDialog" >

      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

  <!--         <div class="side-col sticky">
            <div class="container dark-bg">
              <div class="row pt-0.8 pb-0.8">
 -->

                <div class="modal-header dark-bg">
                  <div class="col-auto me-auto ">
                    <h3>Zaloguj</h3>
                  </div>
                  <div class="col-auto d-flex align-items-center">
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                </div>


       <!--          </div>
              </div>
            </div>
 -->

                <div class="form-control">
                  <form>
                    <div class="PopupLogin">
                      <i class="fas fa-user"></i><input ref="input" type="text" class="form-control " placeholder="Login" v-model="creds['user']" @focus="err=''" @keyup.enter="doLogin"> <br>

                    </div>



                    <div class="PopupHaslo">
                      <i class="fas fa-lock"></i><input ref="input" type="password" class="form-control " placeholder="Hasło" v-model="creds['passwd']" @focus="err=''" @keyup.enter="doLogin"> <br>
                    </div>


                    <div class="PopupError">
                      <p v-if="invalidUser" style="color:red;" class="validateUser">* Nazwa użytkownika nie może być pusta</p>
                      <p v-if="invalidPassword" style="color:red;" class="validatePassword">* Hasło nie może być puste</p>
                      <p v-if="invalidCreds" style="color:red;" class="validatePassword">* Nieprawidłowe dane logowania</p>
                    </div>
                  </form>
                </div>
          <div class="modal-footer d-flex justify-content-around">
            <div class="row" >

              <div class="col-md-1">
              </div>
            <div class="col-md-5 col-xs-6">
              <a class="form-button btn btn-outline-primary btn-lg me-2 login" data-bs-toggle="modal" data-bs-target="#ForgotPasswordModal" id="zapomnialeshasla">zapomniałeś hasła? </a>
            </div>
            <div class="zalogujRow col-md-5 col-xs-7">
              <a class="form-button btn dologin btn-outline-primary btn-lg me-2 login" :class="{ disabled: busy }" @click="doLogin" href="#" >Zaloguj</a>
            </div>
            </div>
          </div>

              </div>

            </div>

    </div>

</template>
<script>

import ZetosForgotPassword from './ForgotPasssword';

  export default {

     components: {
       ZetosForgotPassword
    },
    data() {
      return {


        creds: {},


        isDirty: false,


        err: '',

        // trwa logowanie (CTA zablokowane)
        busy: false,

        modal:null

      }
    },
    methods: {

      doLogin() {


        this.isDirty = true;


        if (this.invalidUser || this.invalidPassword || this.busy) {
          return;
        }

        this.busy = true;



    //    this.$emit('login');


          this.post( '/client/login', {

            client_login: this.creds.user.trim(),
            client_password: this.creds.passwd.trim()

          })
          .then(response => {

            this.busy = false;

            if (!!response.data) {

              let ok = !(response.data.IS_ERROR | 0);



              // due to incompatible income types dictionary and backend name mapping issue we have to remap income type to valid front ids
              let employment = new Map([
                ['-6', '0'],
                ['5', '0'],
                ['20', '0'],
                ['8', '2'],
                ['15', '2'],
                ['-2', '9'],
                ['2', '9'],
                ['4', '9'],
                ['17', '9'],
                ['6', '11'],
                ['18', '11'],
                ['-5', '8'],
                ['7', '8'],
                ['-1', '5'],
                ['9', '5'],
                ['11', '5'],
                ['3', '6']
              ]);


              response.data.hasOwnProperty('income_type_id') 
                && (response.data.income_type_id = employment.has(response.data.income_type_id) ? employment.get(response.data.income_type_id) : '4');



          //    console.log(employment)


       //   console.log(response.data)

              this.echo('logged_in', response.data);


              localStorage.setItem('user', JSON.stringify(response.data));

              this.modal.hide();

              this.$router.push({path: 'client'});


            }


          })
          .catch(error => {

            this.busy = false;


              // Error
              if (error.response) {


               // console.log(error.response.data);


                  if (!!error.response.data.IS_ERROR) {


                    this.err = true; //{...error.response.data.Message};

                    //this.verifycode_hint = error.response.data.Message.toString();
                  }

              }


              //this.form['verifycode'] = '';
              //this.$v.form['verifycode'].$touch();

            //console.log('Network error', error);

          });






      }


    },


    computed: {


      invalidUser() {
        return this.isDirty && !this.creds['user']
      },

      invalidPassword() {
        return this.isDirty && !this.creds['passwd']
      },

      invalidCreds() {
        return this.isDirty && this.err
      }
    },



    created() {


      this.listen('login_dialog', () => {
        this.modal.show();
      });


    },


    mounted(){


      this.modal = new bootstrap.Modal(this.$refs['modal']);
    }


    //bu
  }



</script>
<style scoped>

  .form-button{
    color:#0bc268;
  }
  .form-button:hover{
    color:#fff;
  }
  a.login {

    width:16rem;
  }

  .PopupLogin {
    position: relative;
  }

  .PopupLogin input {
    padding-right: 35px !important;
  }

  .PopupLogin i {
      opacity: .5;
      position: absolute;
      right: 0px;
      padding: 17px 20px;
      pointer-events: none;
    }
  .PopupHaslo {
    position: relative;
  }



    .PopupHaslo input {
      padding-right: 35px !important;
    }

    .PopupHaslo i {
      opacity: .5;
      position: absolute;
      right: 0px;
      padding: 17.5px 19px;
      pointer-events: none;
    }

  .modal-footer {
    justify-content: left;
  }



  b-button {
    width: 250px;
    height: 40px;
    color: white;
    background-color: forestgreen;
    display: flex;
    justify-content: center;
  }

  h5 {
    justify-content: center;
  }

  .modal-dialog {
    overflow-y: initial;
    display: flex;
    justify-content: center;
    max-width:700px;
  }

  .modal-title {
    justify-content: center;
  }

  .modal-header {
    display: flex;
    justify-content: center;
    overflow-y: auto;

    text-align:center;

  }

  .modal-body {
    overflow-y: auto;
    display: flex;
    justify-content: center;
  }



  

  
  @media(max-width: 481px){
    .zalogujRow{
      margin-top:7px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/LoginPopup.vue